export const BRANDS = Object.freeze({
	bz: 'beri-zaryad',
	we53: 'we53',
});

export const LOCALES = Object.freeze({
	en: 'en',
	ru: 'ru',
});
